<script lang="ts">
import type { Snippet } from 'svelte'

import PrivacyNotice from '@/components/content/PrivacyNotice.svelte'
import { testIds } from '@/constants'

type Props = {
	label: string
	isControlHidden: boolean
	isTicketForm?: boolean
	controlCmp?: Snippet
	feedback?: Snippet
}

let { label, isControlHidden, isTicketForm, controlCmp, feedback }: Props = $props()
</script>

<div
	class={['flex items-center pt-1 pb-3', isControlHidden ? 'justify-center' : 'justify-between']}
	data-testid={testIds.authFormPrivacyNotice}
>
	<PrivacyNotice {label} {isTicketForm} />
	{#if controlCmp}
		<div class="ml-2">
			{@render controlCmp()}
		</div>
	{/if}
</div>
{@render feedback?.()}
